export enum WorkOrderStatus {
  NotReady = "NotReady",
  New = "New",
  Assigned = "Assigned",
  Unassigned = "Unassigned",
  Reassigned = "Reassigned",
  Hold = "Hold",
  InProgress = "InProgress",
  Complete = "Complete",
  Cancelled = "Cancelled",
  HoldPreviousDay = "HoldPreviousDay",
  Incomplete = "Incomplete",
}
